import { ThemeProvider } from './providers/ThemeProvider'
import { QueryProvider } from './providers/QueryProvider'
import { AppRoutes } from './routes'

function App() {
  return (
    <ThemeProvider>
      <QueryProvider>
        <AppRoutes />
      </QueryProvider>
    </ThemeProvider>
  )
}

export default App